import { createFileRoute } from '@tanstack/react-router';
import { IntegrationPage } from '@pages/integration';

export const Route = createFileRoute('/_shell/integration')({ component: IntegrationPage });
